"use strict";

var _promise = require("babel-runtime/core-js/promise");
var _promise2 = _interopRequireDefault(_promise);
var _map = require("babel-runtime/core-js/map");
var _map2 = _interopRequireDefault(_map);
var _createClass2 = require("babel-runtime/helpers/createClass");
var _createClass3 = _interopRequireDefault(_createClass2);
var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
var sessionerror_1 = require("../sessionerror");
var ConsumptionReportRequest = function ConsumptionReportRequest() {
  (0, _classCallCheck3.default)(this, ConsumptionReportRequest);
};
var ConsumptionReportEntry = function ConsumptionReportEntry() {
  (0, _classCallCheck3.default)(this, ConsumptionReportEntry);
};
var ConsumptionHorizonPromise = function ConsumptionHorizonPromise() {
  (0, _classCallCheck3.default)(this, ConsumptionHorizonPromise);
};
/**
 * @classdesc Provides consumption horizon management functionality
 */

var ConsumptionHorizon = function () {
  function ConsumptionHorizon(services) {
    (0, _classCallCheck3.default)(this, ConsumptionHorizon);
    this.services = services;
    this.consumptionHorizonRequests = new _map2.default();
    this.consumptionHorizonUpdateTimer = null;
  }
  (0, _createClass3.default)(ConsumptionHorizon, [{
    key: "getReportInterval",
    value: function getReportInterval() {
      return this.services.session.getConsumptionReportInterval().then(function (seconds) {
        return seconds * 1000;
      });
    }
  }, {
    key: "delayedSendConsumptionHorizon",
    value: function delayedSendConsumptionHorizon(delay) {
      var _this = this;
      if (this.consumptionHorizonUpdateTimer !== null) {
        return;
      }
      this.sendConsumptionReport(true);
      this.consumptionHorizonUpdateTimer = setTimeout(function () {
        _this.sendConsumptionReport(false);
      }, delay);
    }
  }, {
    key: "sendConsumptionReport",
    value: function sendConsumptionReport(keepTimer) {
      var _this2 = this;
      var reports = [];
      var promises = new _map2.default();
      this.consumptionHorizonRequests.forEach(function (request, channelSid) {
        reports.push(request.entry);
        promises.set(channelSid, request.promises);
      });
      if (reports.length > 0) {
        this.services.session.addCommand('consumptionReportV2', {
          report: reports
        }).then(function (response) {
          return _this2.processConsumptionReportResponse(response, promises);
        }).catch(function (err) {
          return _this2.processConsumptionReportError(err, promises);
        });
      }
      if (!keepTimer) {
        this.consumptionHorizonUpdateTimer = null;
      }
      this.consumptionHorizonRequests.clear();
    }
  }, {
    key: "processConsumptionReportResponse",
    value: function processConsumptionReportResponse(response, promises) {
      if (response && response.report && Array.isArray(response.report) && response.report.length > 0) {
        response.report.forEach(function (entry) {
          var responseEntry = entry;
          if (promises.has(responseEntry.channelSid)) {
            var unreadMessagesCount = null;
            if (typeof responseEntry.unreadMessagesCount !== 'undefined' && responseEntry.unreadMessagesCount != null) {
              unreadMessagesCount = responseEntry.unreadMessagesCount;
            }
            promises.get(responseEntry.channelSid).forEach(function (promise) {
              return promise.resolve(unreadMessagesCount);
            });
            promises.delete(responseEntry.channelSid);
          }
        });
      }
      this.processConsumptionReportError(new sessionerror_1.SessionError('Error while setting LastConsumedMessageIndex', null), promises);
    }
  }, {
    key: "processConsumptionReportError",
    value: function processConsumptionReportError(err, promises) {
      promises.forEach(function (channelPromises) {
        return channelPromises.forEach(function (promise) {
          return promise.reject(err);
        });
      });
    }
    /**
     * Updates consumption horizon value without any checks
     */
  }, {
    key: "updateLastConsumedMessageIndexForChannel",
    value: function updateLastConsumedMessageIndexForChannel(channelSid, messageIdx) {
      var _this3 = this;
      return new _promise2.default(function (resolve, reject) {
        _this3.addPendingConsumptionHorizonRequest(channelSid, {
          channelSid: channelSid,
          messageIdx: messageIdx
        }, {
          resolve: resolve,
          reject: reject
        });
        _this3.getReportInterval().then(function (delay) {
          return _this3.delayedSendConsumptionHorizon(delay);
        });
      });
    }
    /**
     * Move consumption horizon forward
     */
  }, {
    key: "advanceLastConsumedMessageIndexForChannel",
    value: function advanceLastConsumedMessageIndexForChannel(channelSid, messageIdx, currentChannelLastConsumedIndex) {
      var _this4 = this;
      var currentHorizon = this.consumptionHorizonRequests.get(channelSid);
      return new _promise2.default(function (resolve, reject) {
        if (currentHorizon && currentHorizon.entry) {
          if (currentHorizon.entry.messageIdx >= messageIdx) {
            _this4.addPendingConsumptionHorizonRequest(channelSid, currentHorizon.entry, {
              resolve: resolve,
              reject: reject
            });
          } else {
            _this4.addPendingConsumptionHorizonRequest(channelSid, {
              channelSid: channelSid,
              messageIdx: messageIdx
            }, {
              resolve: resolve,
              reject: reject
            });
          }
        } else {
          if (currentChannelLastConsumedIndex !== null && messageIdx < currentChannelLastConsumedIndex) {
            _this4.addPendingConsumptionHorizonRequest(channelSid, {
              channelSid: channelSid,
              messageIdx: currentChannelLastConsumedIndex
            }, {
              resolve: resolve,
              reject: reject
            });
          } else {
            _this4.addPendingConsumptionHorizonRequest(channelSid, {
              channelSid: channelSid,
              messageIdx: messageIdx
            }, {
              resolve: resolve,
              reject: reject
            });
          }
        }
        _this4.getReportInterval().then(function (delay) {
          return _this4.delayedSendConsumptionHorizon(delay);
        });
      });
    }
  }, {
    key: "addPendingConsumptionHorizonRequest",
    value: function addPendingConsumptionHorizonRequest(channelSid, entry, promise) {
      if (this.consumptionHorizonRequests.has(channelSid)) {
        var request = this.consumptionHorizonRequests.get(channelSid);
        request.entry = entry;
        request.promises.push(promise);
      } else {
        this.consumptionHorizonRequests.set(channelSid, {
          entry: entry,
          promises: [promise]
        });
      }
    }
  }]);
  return ConsumptionHorizon;
}();
exports.ConsumptionHorizon = ConsumptionHorizon;